/**
 * two first-unloads (distinct travels) within this distance, in meters,
 * consolidate (lock) a construction location at their centroid.
 */
export const CONSOLIDATION_DISTANCE_METERS = 50;

/**
 * construction radius fallback, in meters, applied when both the location
 * radius and the client param "default_construction_radius" are unset.
 */
export const FALLBACK_CONSTRUCTION_RADIUS_METERS = 300;

/**
 * Minimum stopped time, in minutes, for a mixer on an automatic travel to enter
 * "Em obra" inside a registered construction, when the client param is unset.
 */
export const DEFAULT_AUTO_TRAVEL_MIN_STOP_MINUTES = 10;

/**
 * Below this distance (meters) between a travel's origin and a destination construction, the
 * effective construction radius narrows to CONDITIONAL_CONSTRUCTION_RADIUS_METERS: a plant this
 * close to a jobsite would otherwise have its own vicinity mistaken for "inside the construction".
 */
export const CONDITIONAL_CONSTRUCTION_RADIUS_TRIGGER_METERS = 500;

/**
 * Narrowed effective construction radius (meters) applied when the travel's origin and the
 * destination construction are closer than CONDITIONAL_CONSTRUCTION_RADIUS_TRIGGER_METERS.
 */
export const CONDITIONAL_CONSTRUCTION_RADIUS_METERS = 30;

/**
 * A discharge farther than the construction radius from a consolidated construction still counts as
 * inside it when at least DISCHARGE_HISTORY_MIN_TRAVELS earlier travels of the same construction
 * discharged within this distance (meters) of it — a jobsite the construction already serves.
 */
export const DISCHARGE_HISTORY_ACCEPTANCE_METERS = 200;

/** Distinct earlier travels that must have discharged near the point for the history to accept it. */
export const DISCHARGE_HISTORY_MIN_TRAVELS = 2;

/** Most recent discharge points of a construction read when checking its history. */
export const DISCHARGE_HISTORY_MAX_POINTS = 500;

/**
 * When a discharge falls outside a consolidated construction and no other open nota contains the point,
 * the nota whose construction is nearest takes the discharge, as long as it is within this distance (meters).
 */
export const NEAREST_TRAVEL_SWAP_MAX_METERS = 1000;

/**
 * A mixer "Em obra" at a consolidated construction that leaves it without discharging only goes to
 * "Retornando" after staying outside for this long (minutes) or getting this far (meters) from it.
 */
export const CONSTRUCTION_EXIT_TOLERANCE_MINUTES = 20;
export const CONSTRUCTION_EXIT_TOLERANCE_METERS = 2000;

/** Oldest valid GPS position (minutes) a discharge command without GPS may borrow. */
export const NO_FIX_LAST_POSITION_MAX_AGE_MINUTES = 30;
